/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TProcessFormAnswersRequest,
  TProcessFormAnswersModel,
  IMappers,
  TProcessFormAnswersResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1ProcessFormAnswersResponseSchema } from '../../entities/response/V1ProcessFormAnswersResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createProcessFormAnswersModel(parameters: TProcessFormAnswersRequest): TProcessFormAnswersModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'legal-check',
    pathApi: '/v1/process-form-answers/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IProcessFormAnswersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TProcessFormAnswersRequest;
}

export async function fetchProcessFormAnswers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IProcessFormAnswersOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TProcessFormAnswersResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createProcessFormAnswersModel(parameters),
    config,
  )) as FetchResponse<TProcessFormAnswersResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1ProcessFormAnswersResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TProcessFormAnswersResponse>;
}
